<template>
  <svg xmlns="http://www.w3.org/2000/svg"
       :width="width"
       :height="height"
       viewBox="0 0 24 24"
       role="presentation"
       @click="$emit('click')">
    <g fill="none" fill-rule="evenodd" stroke="#8067B7" stroke-linecap="round" stroke-width="2">
      <path stroke-linejoin="round" d="M13 12h10M20.084 8.922L23 12M20 15.162L23 12"/>
      <path d="M16 17v1.04a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V5.96a2 2 0 0 1 2-2h7a2 2 0 0 1 2 2V7"/>
    </g>
  </svg>
</template>

<script>
  import iconMixin from './iconMixin.js'

  export default {
    mixins: [iconMixin]
  }
</script>